import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.div`
  position: relative;
  height: 100%;
  display: grid;
  grid-template-rows: 25px 1fr;
  text-align: center;
  overflow-y: hidden;
`
export const LoadingContainer = styled.div`
  flex: 1;
  padding: 1rem;
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Contents = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  display: flex;
  height: 100%;
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  padding: 0 5px;
  table {
    width: 100%;
  }
  tr {
    width: 100%;
    display: grid;
    grid-template-columns: 50% 28% 22%;
    text-align: left;
    padding: 6px;

    td:first-child {
      font: normal normal bold 14px/22px Inter;
      color: ${props => props.theme.colors.color6b7786};
    }
    td {
      font: normal normal normal 14px/22px Inter;
      color: ${props => props.theme.colors.color6b7786};
    }
  }
  .header {
    border-radius: 5px;
    border-top: 5px solid ${({ theme }) => theme.zds.colors.neutral1000};
    background: ${props => props.theme.colors.colorf3f5f9};
    position: sticky;
    top: 0;
    font: normal normal bold 14px/22px Inter;
    color: ${props => props.theme.colors.color6b7786};
  }

  overflow-y: auto;

  ${VerticalStyledScrollBar}
`
export const AlertMessage = styled.div`
  width: 100%;
  height: 100%;
  padding: 5px;
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    color: ${props => props.theme.colors.color6b7786};
    font-family: Inter;
    font-size: 12px;
    font-weight: 22px;
    text-align: center;
  }
`
